export default __webpack_public_path__ + "static/icon-17b6efb202c49948122ae1bda82415d4.png";